// Libraries
import { TypeOf, z } from 'zod';
// Utils
import text from '@translations/en.json';

/**
 * Zod schema for the ForgotPassword form data.
 */
export const ForgotPasswordSchema = z.object({
  /**
   * The username or email address input field.
   */
  username: z.string({
    required_error: text.username_error_message,
  }),
});

/**
 * Represents the type of values accepted by the ForgotPasswordSchema.
 */
export type ForgotPasswordValues = TypeOf<typeof ForgotPasswordSchema>;
